
var sprite = require("D:/a/1/s/Web/CMS/App_Themes/Safestore/node_modules/svg-sprite-loader/lib/web/global-sprite");
var image = "<symbol viewBox=\"0 0 34.765 34.765\" id=\"icon-spinbox-plus\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"> <path d=\"M33.765,14.382c0.552,0,1,0.448,1,1v4c0,0.553-0.448,1-1,1H20.383v13.383c0,0.553-0.448,1-1,1h-4\r\n\tc-0.553,0-1-0.447-1-1V20.382H1c-0.552,0-1-0.447-1-1v-4c0-0.552,0.448-1,1-1h13.383V1c0-0.553,0.447-1,1-1h4c0.552,0,1,0.447,1,1\r\n\tv13.382H33.765z\"/> </symbol>";
module.exports = sprite.add(image, "icon-spinbox-plus");


/*****************
 ** WEBPACK FOOTER
 ** ./svg/src/spinbox-plus.svg
 ** module id = 226
 ** module chunks = 24
 **/